export const Pro_req="Pro_req";
export const Pro_success="Pro_success";
export const Pro_fail="Pro_fail";

export const Pro_det_req="Pro_det_req";
export const Pro_det_success="Pro_det_success";
export const Pro_det_fail="Pro_det_fail";

export const Pro_rev_req="Pro_rev_req";
export const Pro_rev_success="Pro_rev_success";
export const Pro_rev_fail="Pro_rev_fail";
export const Pro_rev_reset="Pro_rev_reset";